/**
 * 大区 API 服务
 * 用于获取大区缓存列表
 * 直接访问后端，与原有方式一致（不需要代理）
 */

// 大区类型
export interface CosRegion {
  id: number;
  name?: string;
  code?: string;
  remark?: string;
  sort?: number;
  status?: number;
  createTime?: number;
  updateTime?: number;
}

export interface CosRegionListResponse {
  code: number;
  message?: string;
  msg?: string;
  data?: {
    total: number;
    list: CosRegion[];
  };
}

export interface CosRegionQueryParams {
  pageNum?: number;
  pageSize?: number;
  name?: string;
  status?: number;
}

/**
 * 获取大区列表（从缓存）
 * 直接访问后端，与原有方式一致（不需要代理）
 */
export async function getRegionList(params?: CosRegionQueryParams): Promise<CosRegionListResponse> {
  // 使用 apiClient，直接访问后端（与原有方式一致，不需要代理）
  const { apiClient } = await import('../config/netConfig');

  const queryParams = new URLSearchParams();
  if (params?.pageNum !== undefined) queryParams.append('pageNum', String(params.pageNum));
  if (params?.pageSize !== undefined) queryParams.append('pageSize', String(params.pageSize));
  if (params?.name) queryParams.append('name', params.name);
  if (params?.status !== undefined) queryParams.append('status', String(params.status));

  const queryString = queryParams.toString();
  const basePath = '/region/list';
  const url = queryString ? `${basePath}?${queryString}` : basePath;

  console.log('📤 请求大区列表（从 cos_region_cache 表，直接访问后端）:', url);
  
  const response = await apiClient.get<CosRegionListResponse>(url);

  console.log('📥 大区列表响应（来自 cos_region_cache 表）:', response.data);
  
  return response.data;
}
